import { render, staticRenderFns } from "./ShowDialogProblema.vue?vue&type=template&id=1fa004fa&scoped=true"
import script from "./ShowDialogProblema.vue?vue&type=script&lang=js"
export * from "./ShowDialogProblema.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogProblema.vue?vue&type=style&index=0&id=1fa004fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa004fa",
  null
  
)

export default component.exports